export default __webpack_public_path__ + "static/media/british-council.90d3be3f.svg";